import { render, staticRenderFns } from "./UserManagementAccVerify.vue?vue&type=template&id=f4c8e48c&scoped=true"
import script from "./UserManagementAccVerify.vue?vue&type=script&lang=js"
export * from "./UserManagementAccVerify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c8e48c",
  null
  
)

export default component.exports